import React from 'react';

const CrosshairSvg = (props) => (
    <svg viewBox="0 0 24 24" {...props}>
        <path
            d="M11 18.93A7.005 7.005 0 0 1 5.07 13H3v-2h2.07A7.005 7.005 0 0 1 11 5.07V3h2v2.07A7.005 7.005 0 0 1 18.93 11H21v2h-2.07A7.005 7.005 0 0 1 13 18.93V21h-2v-2.07zM12 17a5 5 0 1 0 0-10 5 5 0 0 0 0 10zm0-3a2 2 0 1 1 0-4 2 2 0 0 1 0 4z"
            fill="#000"
            fillRule="evenodd"
        />
    </svg>
);

CrosshairSvg.displayName = 'CrosshairSvg';
export default CrosshairSvg;
